import { ProjectData, Tags, Languages, Software, ProjectStatus, Products, Contributors, Technologies, OrientationType } from '@structures/ProjectData';
import { Title, Images } from '@projects/Drop Chat';
import { FileType } from '@models';

export const ImageAssets = Object.values(Images);

export const DropChat: ProjectData = {
    summary: {
        id: "DC",
        title: "Drop Chat",
        orientation: OrientationType.Portrait,
        aliases: ["DC"],
        filter: { settings: { pixelSize: 1 }},
        version: 1.0,
        status: ProjectStatus.Completed,
        initial: new Date(2014, 10, 1),
        release: new Date(2014, 10, 31),
        previews:[{
            file: Title.Title_01,
            type: FileType.Image,
            description: "A dialog with text and two people shows, as well as an emoji if a rattled face.",
            caption: `Main window of the chat application.`
        }],
        tags: {
            [Tags.Products]: [
                Products.Tools
            ],
            [Tags.Software]: [
                Software.VS
            ],
            [Tags.Languages]: [
                Languages.CSharp
            ],
            [Tags.Technologies]: [
                Technologies.WinForms
            ]
        },
        description: "A chat application which utilizes Dropbox to send and receive messages."
    },
    details: {
        description: "This unique chat solution uses Dropbox to pass messages between many users over a network connection."
            + "<br/><br/>"
            + "It was made as a simple way to communicate on a project, where all involved users have shared access.",
        gallery: [{
            file: ImageAssets[0],
            type: FileType.Image,
            description: "An image of a window showing a 'Send' button and a rattled emoji button.",
            caption: "The main window, which allows users to send & receive messages and notifications all through dropbox."
        }],
        contributions: [{
            contributor: Contributors.MakoInfused,
            roles: [{
                title: "Tools Engineer",
                involvement: "Developed all of the tools logic and designed the WinForms UI.",
                achievements: [
                    "Developed application to send, receive and sync messages in real-time.",
                    "Developed a 'poke' button to send out a sound and notification in order to get a coworkers attention!",
                    "Developed a custom data format to store all archived messages and unread messages along with metadata such as timestamps.",
                    "Designed & developed the entire user interface."
                ]
            }]
        }]
    },
};

export default DropChat;